var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgGenericIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 51,
  viewBox: "0 0 60 51",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3254_37968)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 51,
  rx: 6,
  fill: "url(#paint0_linear_3254_37968)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.276732 19.0391L-1 18.6714V20V51V52H0H60H61V51V20V18.6714L59.7233 19.0391L30 27.5987L0.276732 19.0391Z",
  fill: "#FFCA05",
  stroke: "white",
  strokeWidth: 2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3254_37968",
  x1: 30,
  y1: 0,
  x2: 30,
  y2: 31.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCA05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3254_37968"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 51,
  rx: 8,
  fill: "white"
})))));
export default SvgImgGenericIcon;